import { useMutation, useQueryClient } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';

import { PENDENCY_REPORT_QUERY_KEY } from './usePendencyReportQuery';
import { INBOUND_SEARCH_LIST_KEY } from './useSearchInboundListQuery';

/**
 * This is to track the archive Inbound mutation keys in react query cache.
 */
const MUTATE_ARCHIVE_INBOUND = 'archive-inbound-mutation-key';

interface IUseArchiveInboundMutation {
  onSuccessCallback?: (data: any) => void;
}

/**
 * React Query mutation function for archiving an Inbound Transaction
 */
export const useArchiveInboundMutation = ({
  onSuccessCallback,
}: IUseArchiveInboundMutation) => {
  const queryClient = useQueryClient();
  const {
    data,
    error,
    isError,
    isPending,
    mutate: archiveInboundTransaction,
    reset: resetArchiveInboundTransactionMutation,
  } = useMutation({
    mutationKey: [MUTATE_ARCHIVE_INBOUND],
    networkMode: 'always',
    mutationFn: INV_MGMT_SERVICE_API.archiveInboundTransaction,
    onSuccess: (resData) => {
      onSuccessCallback?.(resData);

      queryClient.invalidateQueries({
        queryKey: [INBOUND_SEARCH_LIST_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [PENDENCY_REPORT_QUERY_KEY],
      });
    },
  });

  return {
    archiveInboundTransaction,
    data,
    error,
    isError,
    isPending,
    resetArchiveInboundTransactionMutation,
  };
};
